import React from 'react';
import { Box, Typography } from '@mui/material';
import CopyrightIcon from '@mui/icons-material/Copyright';

const CopyrightNotice = () => {
  return (
    <Box
      sx={{
        // backgroundColor: '#0d47a1',
        color: 'grey',
        // padding: '20px',
        borderRadius: '8px',
        textAlign: 'center',
        // boxShadow: 3,
      }}
    >
      {/* <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2 }}>
        <CopyrightIcon sx={{ fontSize: 40, verticalAlign: 'middle', mr: 1 }} />
        Linkway
      </Typography> */}
      {/* <Typography variant="h6" sx={{ fontStyle: 'italic', mb: 1 }}>
        "Innovating the Connections, Transforming the Future"
      </Typography> */}
      <Typography sx={{ fontSize: '12px' }}>&copy; 2024 Gateway Group. All Rights Reserved.</Typography>
      {/* <Typography variant="body2" sx={{ mt: 1 }}>
        Unauthorized duplication, distribution, or modification is strictly prohibited.
      </Typography> */}
    </Box>
  );
};

export default CopyrightNotice;
